<template>
  <div class="card card-plain new-block">
    <h4 class="card-title new-title mb-0">
      <router-link :to="{ name: 'news-single', params: { item: item.id } }">{{
        item.title
      }}</router-link
      ><br />
      <small class="card-description text-muted">{{ item.date }}</small>
    </h4>

    <div class="card-body p-0">
      <p class="card-description">{{ item.text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
  },
};
</script>
